// extracted by mini-css-extract-plugin
export var numpadContainer = "_s0-1";
export var phoneButton = "_s0-0";